import React, { useState } from 'react';
import clsx from 'clsx';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { SelectPicker } from 'rsuite';
import { Title } from '../developers/page-components/Title';

const paymentTypes = [
	{
		key: 'debit',
		label: 'Debit',
	},
	{
		key: 'credit',
		label: 'Credit',
	},
];

const currencyMockData = [
	{
		value: 'USD',
		label: 'USD'
	}
];

export interface IAdjustmentBodyProps {
	currency: string,
	amount: number | string,
	paymentType?: string
}

interface Props {
	closeModal: () => void;
	onFormSubmit: (body: IAdjustmentBodyProps ) => Promise<void>;
	reserve?: boolean
}

export const AdjustmentModalContent = (props: Props): React.ReactElement => {
	const { closeModal, onFormSubmit, reserve } = props;
	const [amount, setAmount] = useState<number| string>('');
	const [currency, setCurrency] = useState<string>('USD');
	const [paymentType, setPaymentType] = useState<string>('debit');
	const [errorText, setErrorText] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(false);

	const handleChange = (e): void => {
		const value = e.target.value;
		setAmount(value === '' ? undefined : Number(value));
		setErrorText('');
	};

	const handleSubmit = async (e): Promise<void> => {
		e.preventDefault();
		if (!amount) {
			setErrorText('Amount is required');
			return;
		}
		if (amount < 0) {
			setErrorText('Amount must be a positive number');
			return;
		}
		setLoading(true);
		const body: IAdjustmentBodyProps = {
			currency,
			amount,
			paymentType
		};
		await onFormSubmit(body);
		closeModal();
		setLoading(false);
	};
	return (
		<>
			<form className="px-10 mt-10 row" onSubmit={handleSubmit}>
				<div className="col-4">
					<Title title='Currency' additionalClass='mb-2'/>
					<SelectPicker
						className="p-0 select-picker"
						data={currencyMockData}
						value={currency}
						defaultValue='USD'
						onChange={setCurrency}
						disabled={true}
						searchable={false}
						cleanable={false}
					/>
				</div>
				<div className="col-6 input-container position-relative">
					<label className="form-label col-12">
						Amount
						<input
							type='number'
							step="0.01"
							className="form-control form-control-sm form-control-solid mb-10 mt-1 number-input-zip"
							placeholder='Enter amount'
							value={amount}
							onChange={handleChange}
						/>
					</label>
					{
						errorText && (
							<span className="error-container text-danger fs-8">{errorText}</span>
						)
					}
				</div>

				{!reserve && (
					<>
						{
							paymentTypes.map(({ key, label }) => (
								<div
									className={clsx(
										'd-flex justify-content-start align-items-center col-4',
									)}
									key={key}
								>
									<input
										className="custom-radio-input"
										type="radio"
										id={key}
										name="role"
										value={key}
										checked={key === paymentType}
										onChange={(): void => setPaymentType(key)}
									/>
									<label htmlFor={key} className="d-flex flex-column align-items-start justify-content-between label-alignments cursor-pointer">
										<div className="fs-5 fw-bolder">
											{label}
										</div>
									</label>
								</div>
							))
						}
					</>
				)}

				<div className="d-flex align-items-center justify-content-center mt-10 mb-5">
					<ButtonComponent
						buttonName='Cancel'
						additionalClass="btn-sm me-20"
						buttonType={BUTTON_TYPE.CANCELLED}
						onButtonClick={closeModal}
					/>
					<ButtonComponent
						buttonName='Confirm'
						additionalClass="btn-sm w-100px"
						type='submit'
						loading={loading}
						isDisabled={loading}
					/>
				</div>
			</form>
		</>
	);
};
